// Undo history for the drawing canvas.
//
// Every entry is a full-canvas ImageData (4 bytes per pixel, canvas = CSS size x
// devicePixelRatio): about 2.4 MB at dpr 2 and 5.5 MB at dpr 3 for a 16:9 canvas, so
// a count limit alone (50) can still reach 120-270 MB, which crashes phone browsers.
// This keeps the history under BOTH a step count and a byte budget.

export const MAX_HISTORY_STEPS = 50;
export const MAX_HISTORY_BYTES = 64 * 1024 * 1024;

const sizeOf = (snap) => snap?.data?.byteLength || 0;

/**
 * Returns the new history after taking a snapshot at `index` (anything after the
 * current position is discarded first - a new stroke after undo drops the redo
 * branch). The OLDEST steps are evicted until both limits hold, but always keeping
 * at least 2 (the baseline plus the latest) so undo never loses the whole drawing.
 */
export function pushHistory(history, index, snapshot, { maxSteps = MAX_HISTORY_STEPS, maxBytes = MAX_HISTORY_BYTES } = {}) {
  const next = [...history.slice(0, index + 1), snapshot];
  let total = next.reduce((n, h) => n + sizeOf(h), 0);
  while (next.length > maxSteps || (total > maxBytes && next.length > 2)) {
    total -= sizeOf(next[0]);
    next.shift();
  }
  return next;
}

export function historyBytes(history) {
  return history.reduce((n, h) => n + sizeOf(h), 0);
}
